export default __webpack_public_path__ + "static/media/step3-5.eec1de1b.jpg";